import IMG1 from "./images/card1.jpg";
import IMG2 from "./images/card2.jpg";
import IMG3 from "./images/card3.jpg";
import IMG4 from "./images/card4.jpg";
import IMG5 from "./images/card5.jpg";
import IMG6 from "./images/card6.jpg";
import IMG7 from "./images/card7.jpg";
import IMG8 from "./images/card8.jpg";
import IMG9 from "./images/card9.jpg";

const uniqueCardsArray = [
  {
    type: "card3",
    image: IMG1,
  },
  {
    type: "card5",
    image: IMG2,
  },
  {
    type: "card6",
    image: IMG3,
  },
  {
    type: "card7",
    image: IMG4,
  },
  {
    type: "card8",
    image: IMG5,
  },
  {
    type: "card2",
    image: IMG6,
  },
  {
    type: "card4",
    image: IMG7,
  },
  {
    type: "card9",
    image: IMG8,
  },
  {
    type: "card1",
    image: IMG9,
  },
];

export default uniqueCardsArray;